import { render, staticRenderFns } from "./TgWishcardSmall.vue?vue&type=template&id=cf376a6e&scoped=true&"
import script from "./TgWishcardSmall.vue?vue&type=script&lang=js&"
export * from "./TgWishcardSmall.vue?vue&type=script&lang=js&"
import style0 from "./TgWishcardSmall.vue?vue&type=style&index=0&id=cf376a6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf376a6e",
  null
  
)

export default component.exports